<template>
    <v-card width="100%" flat>
        <v-card-title>
            <div class="headline">
                Bloky
            </div>
            <v-spacer></v-spacer>

            <v-combobox
                    clearable
                    single-line
                    hide-details
                    class="pt-0"
                    label="Filtrovat podle události"
                    :items="eventList"
                    item-value="id"
                    item-text="name"
                    v-model="selectedEvent"
            ></v-combobox>

            <v-spacer></v-spacer>

            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Vyhledávání"
                    single-line
                    class="pt-0"
                    hide-details
            ></v-text-field>
        </v-card-title>

        <v-data-table
                v-model="selected"
                :headers="headers"
                :items="filteredItems"
                :search="search"
                class="elevation-2"
                dense
                :footer-props="{
                    'items-per-page-options': [10, 20, 50, 100, 500, 1000]
                }"
        >
<!--            show-select-->
            <template v-slot:item.validate="{ item }">
                <v-icon v-if="item.validate" small color="green">check_circle</v-icon>
                <v-icon v-if="!item.validate" small color="red">remove_circle</v-icon>
            </template>

            <template v-slot:item.action="{ item }">
                <EditDeleteActions :hideDelete="true"
                        @edit="editItem(item)"
                />
            </template>

<!--            <template slot="items" slot-scope="props">-->
<!--                <td width="200">-->
<!--                    &lt;!&ndash;{{ props.item.customName }}&ndash;&gt;-->
<!--                    <v-edit-dialog-->
<!--                            :return-value.sync="props.item.customName"-->
<!--                            lazy-->
<!--                            @save="saveCustomName(props.item)"-->
<!--                    >-->
<!--                        {{ props.item.customName }}-->

<!--                        <template v-slot:input>-->
<!--                            <v-text-field-->
<!--                                    v-model="props.item.customName"-->
<!--                                    label="Upravit"-->
<!--                                    single-line-->
<!--                            ></v-text-field>-->
<!--                        </template>-->
<!--                    </v-edit-dialog>-->
<!--                </td>-->
<!--                <td width="50">-->
<!--                    <v-btn flat icon @click="toggleValidate(props.item.id, !props.item.validate, props.item)">-->
<!--                        <v-icon v-if="props.item.validate" small color="green">check_circle</v-icon>-->
<!--                        <v-icon v-if="!props.item.validate" small color="red">remove_circle</v-icon>-->
<!--                    </v-btn>-->
<!--                </td>-->
<!--                <td width="50">{{ props.item.ticketCount }}</td>-->
<!--                <td width="50">{{ props.item.validatedCount }}</td>-->
<!--            </template>-->
        </v-data-table>

        <EventBlockDialog ref="dialog" @complete="onComplete" />

        <DeleteConfirm :show="deleteConfirm"
                       @confirm="doDeleteConfirm"
                       @cancel="deleteConfirm=false"
        />
    </v-card>
</template>

<script>
    import BaseListMixin from '../mixins/BaseListMixin'
    import EventBlockDialog from '../components/dialogs/EventBlockDialog'

    export default {
        mixins: [BaseListMixin],

        components: {
            EventBlockDialog
        },

        data () {
            return {
                module: 'eventBlock',
                headers: [
                    { text: 'Jméno', value: 'name' },
                    // { text: 'Hláška při kontrole', value: 'customName', width: '200px'},
                    { text: 'Událost', value: 'event.name' },
                    { text: 'Vstupů', value: 'people', width: '100px', align:'center' },
                    { text: 'Minut mezi vstupy', value: 'entryPause', width: '150px', align:'center' },
                    // { text: 'Prefix', value: 'prefix', width:'100px' },
                    { text: 'Hláška', value: 'validate', width: '100px', align:'center' },
                    { text: 'Vstupenek', value: 'ticketCount', width: '120px', align:'right' },
                    { text: 'Ověřeno', value: 'validatedCount', width: '120px', align:'right'},
                    { text: '', value: 'action', sortable: false},
                ],
                selectedEvent: null
            }
        },

        mounted () {
            this.$store.dispatch('event/list')
        },

        computed: {
            eventList () {
                return this.$store.state.event.list
            },

            filteredItems () {
                return this.$store.state.eventBlock.list.reduce((acc, block) => {
                    if (this.selectedEvent) {
                        if (this.selectedEvent.id === block.event.id) {
                            return [...acc, block]
                        } else {
                            return acc
                        }
                    } else {
                        return [...acc, block]
                    }
                }, [])
            }
        },

        methods: {
            // toggleValidate(blockId, validate, item) {
            //     this.$store.dispatch('blockValidate', {blockId:blockId, validate:validate})
            //         .then(result => {
            //             if (result.ok) {
            //                 this.$store.dispatch('events')
            //             }
            //         })
            // },
            //
            // saveCustomName (item) {
            //     this.$store.dispatch('blockUpdate', {
            //         id: item.id,
            //         name: 'custom_name',
            //         value: item.customName
            //     })
            //     this.$store.dispatch('events')
            // }
        }
    }
</script>
